import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import debounce from 'lodash.debounce';
import { getRequest, putRequest } from '../../requestUtils';
import StatusChangeForm from '../common/StatusChangeForm';
import StatusTracking from '../common/StatusTracking';
import spinnerDNA from '../../../assets/images/spinner-DNA-2s-200px.svg';
import './StatusChange.scss';
var StatusChange = /*#__PURE__*/function (_Component) {
  function StatusChange(props) {
    var _this;
    _classCallCheck(this, StatusChange);
    _this = _callSuper(this, StatusChange);
    _this.state = {
      modelOptions: props.modelOptions,
      modalStatusOptions: props.modalStatusOptions,
      modelStatusTracking: props.modelStatusTracking,
      modelSelected: props.modelSelected,
      modelStatus: props.modelStatus,
      modelName: props.modelName,
      reason: '',
      isLoading: false,
      error: ''
    };
    _this.getSelectedModel = debounce(_this.getSelectedModel.bind(_this), 500);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.updateUrl = _this.updateUrl.bind(_this);
    _this.renderStatusTracking = _this.renderStatusTracking.bind(_this);
    return _this;
  }
  _inherits(StatusChange, _Component);
  return _createClass(StatusChange, [{
    key: "getSelectedModel",
    value: function getSelectedModel(resourceId) {
      var _this2 = this;
      var csrfToken = this.props.csrfToken;
      var modelName = this.state.modelName;
      this.setState({
        isLoading: true
      });
      getRequest("/".concat(modelName.toLowerCase(), "s/status_change?resource_id=").concat(resourceId), csrfToken).then(function (res) {
        var data = res.data;
        _this2.setState({
          modelStatusTracking: data.modelStatusTracking,
          modelSelected: data.modelSelected,
          modelStatus: data.modelStatus,
          isLoading: false
        });
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(input, value) {
      if (input === 'modelSelected') {
        this.updateUrl(value.value);
      }
      this.setState(_defineProperty(_defineProperty({}, input, value), "error", ''));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$state = this.state,
        modelSelected = _this$state.modelSelected,
        modelStatus = _this$state.modelStatus,
        reason = _this$state.reason,
        modelName = _this$state.modelName;
      var csrfToken = this.props.csrfToken;
      this.setState({
        isLoading: true
      });
      putRequest("/".concat(modelName.toLowerCase(), "s/").concat(modelSelected.value, "/admin_status_update"), {
        new_status: modelStatus.value,
        reason: reason
      }, csrfToken).then(function (res) {
        if (res.status === 200) {
          var data = res.data;
          _this3.setState({
            modelStatusTracking: data.status_changes,
            isLoading: false,
            reason: ''
          });
        }
      })["catch"](function (e) {
        _this3.setState({
          error: e.message,
          isLoading: false
        });
      });
    }
  }, {
    key: "updateUrl",
    value: function updateUrl(value) {
      var modelName = this.state.modelName;
      var url;
      if (value) {
        url = "/".concat(modelName.toLowerCase(), "s/status_change?resource_id=").concat(value);
        this.getSelectedModel(value);
      } else {
        url = "/".concat(modelName.toLowerCase(), "s/status_change");
        this.setState({
          modelStatusTracking: []
        });
      }
      window.history.replaceState(null, null, url);
    }
  }, {
    key: "renderStatusTracking",
    value: function renderStatusTracking() {
      var _this$state2 = this.state,
        modelSelected = _this$state2.modelSelected,
        modelStatusTracking = _this$state2.modelStatusTracking,
        isLoading = _this$state2.isLoading,
        modelName = _this$state2.modelName;
      if (!modelSelected) {
        return /*#__PURE__*/React.createElement("h2", null, "Select a ".concat(modelName, " to view status tracking"));
      }
      if (modelSelected && modelStatusTracking.length === 0 && !isLoading) {
        return /*#__PURE__*/React.createElement("h2", null, "No status tracking history for this ".concat(modelName));
      }
      return /*#__PURE__*/React.createElement(StatusTracking, {
        statusTracking: modelStatusTracking
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
        modelOptions = _this$state3.modelOptions,
        modalStatusOptions = _this$state3.modalStatusOptions,
        modelSelected = _this$state3.modelSelected,
        modelStatus = _this$state3.modelStatus,
        reason = _this$state3.reason,
        isLoading = _this$state3.isLoading,
        error = _this$state3.error,
        modelName = _this$state3.modelName;
      var submitButtonDisabled = !modelSelected || !modelStatus || !reason;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StatusChangeForm, {
        title: "Change ".concat(modelName, " Status"),
        modelName: modelName.toLowerCase(),
        modelOptions: modelOptions,
        modalStatusOptions: modalStatusOptions,
        modelSelected: modelSelected,
        modelStatus: modelStatus,
        reason: reason,
        handleInputChange: this.handleInputChange,
        submitButtonDisabled: submitButtonDisabled,
        handleSubmit: this.handleSubmit,
        error: error
      }), /*#__PURE__*/React.createElement("div", {
        className: "status-tracking-history"
      }, isLoading ? /*#__PURE__*/React.createElement(SVG, {
        src: spinnerDNA,
        title: "Cloar Spinner"
      }) : this.renderStatusTracking()));
    }
  }]);
}(Component);
StatusChange.propTypes = {
  modelOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  modalStatusOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  modelSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })]).isRequired,
  modelStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })]).isRequired,
  modelStatusTracking: PropTypes.arrayOf(PropTypes.shape({})),
  csrfToken: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired
};
StatusChange.defaultProps = {
  modelStatusTracking: []
};
export default StatusChange;